import { PhoneInput } from '../../phone-input.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderPhoneField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    return (
        <PhoneInput
            key={key}
            label={t(field.label)}
            value={ctx.form[key] as string}
            onChange={ctx.set(key)}
            dialCode={ctx.dialCode ?? ''}
            disabled={ctx.formDisabled}
            inputTestId={getFieldTestId(ctx, key, 'input')}
            data-testid={getFieldTestId(ctx, key, 'phone-input')}
        />
    )
}

renderPhoneField.areCtxEqual = (a, b) => a.dialCode === b.dialCode

export default renderPhoneField
